module.exports = __webpack_public_path__ + "cancel_white-v1-4663b958.svg";